<template>
  <svg
    :class="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9212_68193)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#26A17B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4416 13.0363V13.0348C13.3591 13.0408 12.9338 13.0663 11.9851 13.0663C11.2276 13.0663 10.6943 13.0438 10.5068 13.0348V13.037C7.59085 12.9088 5.41435 12.401 5.41435 11.7935C5.41435 11.1868 7.59085 10.679 10.5068 10.5485V12.5315C10.6973 12.545 11.2433 12.5773 11.9978 12.5773C12.9031 12.5773 13.3568 12.5398 13.4416 12.5323V10.55C16.3516 10.6798 18.5228 11.1875 18.5228 11.7935C18.5228 12.401 16.3516 12.9073 13.4416 13.0363ZM13.4416 10.3438V8.56928H17.5021V5.86328H6.44635V8.56928H10.5068V10.343C7.20685 10.4945 4.7251 11.1485 4.7251 11.9315C4.7251 12.7145 7.20685 13.3678 10.5068 13.52V19.2065H13.4416V13.5185C16.7363 13.367 19.2121 12.7138 19.2121 11.9315C19.2121 11.1493 16.7363 10.496 13.4416 10.3438Z"
        fill="white"
      />
    </g>
    <circle
      cx="19.5"
      cy="19.5"
      r="4.45"
      fill="white"
      stroke="#E0E0E0"
      stroke-width="0.1"
    />
    <path
      d="M19.3399 20.8049V16.5L17.2778 20.0411L19.3399 20.8049Z"
      fill="#4F46E5"
    />
    <path
      d="M19.7139 21.2019V22.8734L21.8041 20.4277L19.7139 21.2019Z"
      fill="#4F46E5"
    />
    <path
      d="M19.7139 16.5V20.8049L21.7759 20.0411L19.7139 16.5Z"
      fill="#4F46E5"
    />
    <path
      d="M19.3401 21.2019L17.25 20.4277L19.3401 22.8734V21.2019Z"
      fill="#4F46E5"
    />
    <defs>
      <clipPath id="clip0_9212_68193">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'h-6 w-6'
    }
  }
}
</script>
